import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const START_HOURS = [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];
export const PROGRAM_START = "2026-12-19";
const fmt = (h, m = 0) => `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
export const sessionLabel = (h) => `${fmt(h)} – ${fmt(h + 1, 30)}`;

const minDate = () => {
  const d = new Date();
  const today = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  return today > PROGRAM_START ? today : PROGRAM_START;
};

export const SessionPicker = ({ index, value, onChange, takenDates, takenPairs = [], testPrefix = "jr-session" }) => {
  const [slots, setSlots] = useState(null);

  useEffect(() => {
    if (!value.date) return;
    setSlots(null);
    axios.get(`${API}/availability/dj_room/${value.date}?junior=true`).then((r) => {
      const map = Object.fromEntries((r.data.available_slots || []).map((s) => [s.hour, s.available]));
      setSlots(START_HOURS.filter((h) => map[h] && map[h + 1]));
    }).catch(() => setSlots([]));
  }, [value.date]);

  const dupe = value.date && takenDates.includes(value.date);

  return (
    <div className="rounded-2xl p-4 bg-dream-bg/60 border border-white/10" data-testid={`${testPrefix}-${index}`}>
      <p className="text-lime-300 text-xs font-mono uppercase tracking-widest mb-3">Session {index + 1}</p>
      <div className="grid sm:grid-cols-2 gap-3">
        <input
          type="date"
          min={minDate()}
          value={value.date}
          onChange={(e) => onChange({ date: e.target.value, hour: null })}
          className="h-11 px-3 rounded-lg bg-dream-surface border border-white/15 text-white [color-scheme:dark]"
          data-testid={`${testPrefix}-date-${index}`}
        />
        <select
          value={value.hour ?? ""}
          disabled={!value.date || !slots || dupe}
          onChange={(e) => onChange({ ...value, hour: Number(e.target.value) })}
          className="h-11 px-3 rounded-lg bg-dream-surface border border-white/15 text-white disabled:opacity-50"
          data-testid={`${testPrefix}-time-${index}`}
        >
          <option value="">{!value.date ? "Pick a date first" : !slots ? "Loading times…" : slots.length ? "Choose a time" : "No times left this day"}</option>
          {(slots || []).filter((h) => !takenPairs.some(([d, x]) => d === value.date && Math.abs(x - h) < 2)).map((h) => <option key={h} value={h}>{sessionLabel(h)}</option>)}
        </select>
      </div>
      {dupe && <p className="text-red-400 text-xs mt-2">Each session needs a different day.</p>}
    </div>
  );
};
